var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "app-navigation-entry__multiselect" },
    [
      _c(
        "Multiselect",
        {
          class: { showContent: _vm.inputGiven, "icon-loading": _vm.isLoading },
          attrs: {
            options: _vm.usersOrGroups,
            searchable: true,
            "internal-search": false,
            "max-height": 600,
            "show-no-results": true,
            placeholder: _vm.$t("calendar", "Share with users or groups"),
            "user-select": true,
            "open-direction": "bottom",
            "track-by": "user",
            label: "user"
          },
          on: { "search-change": _vm.findSharee, change: _vm.shareCalendar }
        },
        [
          _c("span", { attrs: { slot: "noResult" }, slot: "noResult" }, [
            _vm._v(_vm._s(_vm.$t("calendar", "No users or groups")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }